<template>
  <div>
    <form method="post" class="search-zipcode-form" autocomplete="off" @submit.prevent="submitBlog()">
      
      <fieldset class="form-group">
        <label for="title">Title</label>
        <input id="title" @input="validateInput" class="form-control" type="text" v-model="title" name="title">
      </fieldset>
      <div class="form-group form-check">
        <input type="checkbox" class="form-check-input" id="featured" v-model="isActive">
        <label class="form-check-label" for="featured">Active</label>
      </div>
      <div class="d-flex align-items-center">
        <div class="form-group form-check w-50 pl-0">
          <label class=" pl-0" for="featured">Post Date</label>
        <input type="date" class=" ml-0" id="featured" :value="formattedPostDate" @input="updatePostDate">
      </div>
      <div class="form-group">
              <label for="state">Select State</label>
              <select
                class="form-control"
                name="state"
                v-model="state"
              >
               <option value="">Select State</option>
                <option
                  v-for="option in getStates"
                  :key="option"
                  :value="option"
                  >{{ option }}</option
                >
              </select>
      </div>
 
      </div>


      <fieldset class="form-group" v-if="blog && blog.id">
        <label for="pageUrl">Page Url</label>
        <a id="pageUrl" class="form-control h-auto" target="_blank" :href="getLink()" name="pageUrl">{{getLink()}}</a>
      </fieldset>

      <fieldset class="form-group">
        <label for="cover-image">Cover Image</label>
        <input ref="fileInput" id="cover-image" accept="image/png,image/jpeg,image/jpg" type="file" autocomplete="off"
          tabindex="-1" style="display: none;" @change="onChangeFileInput" />
        <CButton class="btn btn-outline-secondary" @click="choosePhoto" :disabled="uploadLoading">
          Choose a profile photo
        </CButton>
        <div>
          <img :src="coverImageSrc" alt="" v-if="!!coverImageSrc"
            style="max-width: 100px; max-height: 100px; margin-top: 10px;">
        </div>
      </fieldset>
      <p :if="!!coverImgErrorMsg" class="text-danger">{{ coverImgErrorMsg }}</p>

      <fieldset class="form-group">
        <label for="cover-img-alt">Cover Image Alt</label>
        <input id="cover-img-alt" class="form-control" type="text" v-model="coverImgAlt" name="coverImgAlt">
      </fieldset>

      <fieldset class="form-group">
        <label for="page-title">Page Title</label>
        <input id="page-title" class="form-control" type="text" v-model="pageTitle" name="pageTitle">
      </fieldset>

      <fieldset class="form-group">
        <label for="meta-description">Meta Description</label>
        <input id="meta-description" class="form-control" type="text" v-model="metaDescription" name="metaDescription">
      </fieldset>

      <fieldset class="form-group">
        <label for="meta-keywords">Meta Keywords (Separate keywords by comma)</label>
        <input id="meta-keywords" class="form-control" type="text" v-model="metaKeywords" name="metaKeywords">
      </fieldset>

      <fieldset class="form-group">
        <label for="content">Content</label>
        <ckeditor :editor="editor" v-model="content" :config="editorConfig" aria-placeholder="Please type here...">
        </ckeditor>
      </fieldset>

      <button type="submit" class="btn btn-primary btn-lg submit d-block ml-auto mr-auto"
        :class="{ disabled: isDisabled }" :disabled="isDisabled">Save</button>
        <div v-if="message" class="mt-2">
          <div class="alert alert-danger">{{ message }}</div>
        </div>
    </form>
  </div>
</template>

<script>
// import ClassicEditor from 'ckeditor5-build-classic-base64-upload-adapter'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

import {
  createVdpArticleMixin,
  vdpArticleStore,
} from "@/mixins/vdpArticleMixin";
import {
  createMarketplaceMixin,
  marketplaceStore,
} from "@/mixins/marketplaceMixin";
import {
  modalStore,
} from "@/mixins/modalsMixin";
import localStorage from '@/utils/localStorage';
import API from "@/api";
import slugify from 'slugify';
import {readAsDataURL} from '@/utils/AsyncFileReader'
import moment from 'moment'
import URLS from '@/constants/url'

export default {
  name: 'VVdpArticleForm',
  mixins: [createVdpArticleMixin(), createMarketplaceMixin()],
  data() {
    return {
      title: '',
      state: '',
      content: '',
      pageUrl: '',
      coverImgAlt: '',
      coverImageSrc: '',
      pageTitle: '',
      metaDescription: '',
      metaKeywords: '',
      isDisabled: false,
      uploadLoading: false,
      coverImgErrorMsg: '',
      isActive: false,
      postDate: new Date().toISOString(),
      editor: ClassicEditor,
      message: "",
      editorConfig: {
        // extraPlugins: [ MyCustomUploadAdapterPlugin ],
        // The configuration of the editor.
        // extraPlugins: 'youtube'
        ckfinder: {
          // The URL that the images are uploaded to.
          uploadUrl: "/uploads",
          // Enable the XMLHttpRequest.withCredentials property.
          // withCredentials: true,

          // Headers sent along with the XMLHttpRequest to the upload server.
          headers: {
            // "X-CSRF-TOKEN": "CSFR-Token",
            Authorization: `${localStorage.getToken()}`,
          },
        },
      }
    };
  },
  props: {
    blog: {
      type: Object,
      default: null
    }
  },
  watch: {
    blog() {
      if (this.$props.blog) {
        this.title = this.$props.blog.title || ''
        this.content = this.$props.blog.content || ''
        this.coverImageSrc = this.$props.blog.coverImage || ''
        this.coverImgAlt = this.$props.blog.coverImgAlt || ''
        this.state = this.$props.blog.state
        this.pageTitle = this.$props.blog.pageTitle || ''
        this.metaDescription = this.$props.blog.metaDescription || ''
        this.metaKeywords = this.$props.blog.metaKeywords || ''
        this.pageUrl = this.$props.blog.pageUrl || ''
        this.isActive = this.$props.blog.isActive || false
        this.postDate = this.$props.blog.postDate || new Date()
        this.postDate = moment(this.postDate).toDate()
      }
    },
    title() {
      // this.pageUrl = slugify(this.title, {
      //   replacement: "-", // replace spaces with replacement character, defaults to `-`
      //   remove: undefined, // remove characters that match regex, defaults to `undefined`
      //   lower: false, // convert to lower case, defaults to `false`
      //   strict: true, // strip special characters except replacement, defaults to `false`
      //   locale: "vi", // language code of the locale to use
      //   trim: true, // trim leading and trailing replacement chars, defaults to `true`
      // });
    }
  },
  methods: {
    validateInput() {
      const regex = /^[A-Za-z0-9 _-]*$/;
      if (!regex.test(this.title)) {
        console.log("validateInput")

        this.message = "Only alphanumeric characters are allowed.";
        // Remove non-alphanumeric characters
        this.title = this.title.replace(/[^A-Za-z0-9 _-]/g, '');
      } else {
        console.log("validateInput pass")

        this.message = '';
      }
    },
    getLink() {
      if(this.$props.blog && this.$props.blog.uuid){
      return `${URLS.app}/resources/${this.$props.blog.title.toLowerCase().replace(/\s+/g, '-')}`
      }
      else
       null

    },
    updatePostDate(event) {
      // Update the postDate when the user selects a new date
      const selectedDate = event.target.value;
      this.postDate = new Date(selectedDate).toISOString();
    },
    resetData() {
      this.title = ''
      this.content = ''
      this.pageUrl = ''
      this.coverImgAlt = ''
      this.coverImageSrc = ''
      this.pageTitle = ''
      this.metaDescription = ''
      this.metaKeywords = ''
      this.isDisabled = false
      this.uploadLoading = false
      this.coverImgErrorMsg = ''
      this.isActive = false
      this.postDate = new Date().toISOString()
      this.state = ''
    },
    async submitBlog() {
      const isUpdateReq = (this.$props.blog && this.$props.blog.id);
      try {
        this.isDisabled = true
        let blogObj = {
          title: this.title,
          content: this.content,
          coverImage: this.coverImageSrc,
          coverImgAlt: this.coverImgAlt,
          pageTitle: this.pageTitle,
          metaDescription: this.metaDescription,
          metaKeywords: this.metaKeywords,
          isActive: this.isActive,
          postDate: this.postDate,
          state: this.state
        };
        if (isUpdateReq) {
          blogObj['pageUrl'] = ` /resources/${this.$props.blog.title}`;
          const blogId = this.$props.blog.id;
          await this[vdpArticleStore.actionTypes.ACTION_EDIT_VDP_ARTICLE]({ blogId, blog: blogObj });
          // this.message = ``
          // this.closeModal()
          this.$modals.open({
          title: 'Updated successfully',
          body: `Article <strong>${ blogObj.title }</strong> was updated.`
        })
        setTimeout(() => {
          this.$modals.close()
          this.closeModal()
          this.resetData();

        }, 3000)
        } else {
          try{
            const vdpArticle = await this[vdpArticleStore.actionTypes.ACTION_ADD_VDP_ARTICLE](blogObj);
            console.log("vdpArticle",vdpArticle)
            // this.closeModal()
            this.$modals.open({
              title: 'Created successfully',
              body: `Article <strong>${ blogObj.title }</strong> was Created.`
            })
            setTimeout(() => {
              this.$modals.close()
              this.closeModal()
              this.resetData();

            }, 3000)
          }catch(err){
            console.log("error in adding form", err)
            this.message = err
          }
        }

      } catch (error) {
        console.log(error)
        console.log(error.response)
      } finally {
        this.isDisabled = false
      }
    },
    closeModal() {
      setTimeout(() => {
        this.$store.dispatch(
          `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
          null
        )
      }, 500)
      this.$modals.close()
    },
    choosePhoto() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    checkImageSize(src) {
      // Initiate the JavaScript Image object.
      const image = new Image();
      // Set the Base64 string return from FileReader as source.
      image.src = src;
      return new Promise((resolve, reject) => {
        //Validate the File Height and Width.
        image.onload = function () {
          const height = this.height;
          const width = this.width;
          if (height < 600 || width < 1440) {
            reject({ imgSize: true, message: 'Image height 600px and width 1440px is allowed' })
          } else resolve('')
        };
      })
    },
    async onChangeFileInput(event) {
      try {
        this.uploadLoading = true;
        const file = event.target.files[0];
        const imgBase64 = await readAsDataURL(event.target.files[0]);
        // await this.checkImageSize(imgBase64);
        this.coverImgErrorMsg = ''
        const formData = new FormData();
        formData.append('upload', file)

        const { data } = await API.vdpManager.uploadCoverImage(formData);
        this.coverImageSrc = data.url;
      } catch (error) {
        console.log(error)
        if (error && error.imgSize) {
          this.coverImgErrorMsg = 'Image height >= 600 px and width >= 1440 px is allowed'
        }
        this.coverImageSrc = '';
      } finally {
        this.uploadLoading = false;
      }
    },
  },
  computed: {
    getStates(){
      return this[marketplaceStore.getterTypes.GETTER_STATES];
    },
    formattedPostDate() {
      // Extract the date part from the received date
      const datePart = new Date(this.postDate).toISOString().split('T')[0];
      return datePart;
    }
  }
}
</script>
